import { render, staticRenderFns } from "./EmployerMessage.vue?vue&type=template&id=02f57850&scoped=true&"
import script from "./EmployerMessage.vue?vue&type=script&lang=js&"
export * from "./EmployerMessage.vue?vue&type=script&lang=js&"
import style0 from "./EmployerMessage.vue?vue&type=style&index=0&id=02f57850&scoped=true&lang=scss&"
import style1 from "./EmployerMessage.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02f57850",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSnackbar } from 'vuetify/lib/components/VSnackbar';
installComponents(component, {VAlert,VCard,VCol,VContainer,VDivider,VIcon,VProgressCircular,VRow,VSnackbar})
